import { useCallback } from 'react'

export const useFileDownloader = () => {
	const download = useCallback((data: Blob, fileName: string) => {
		if (!data) return
		const url = window.URL.createObjectURL(new Blob([data]))
		const link = document.createElement('a')
		link.href = url
		link.setAttribute('download', fileName)
		document.body.appendChild(link)
		link.click()
		link.parentNode?.removeChild(link)
		window.URL.revokeObjectURL(url)
	}, [])

	return download
}
